<template>
  <v-layout>
    <!-- 모바일 햄버거 버튼 -->
    <v-btn
      v-if="authStore.token"
      icon
      size="small"
      class="d-flex d-md-none"
      style="position:fixed;top:12px;left:12px;z-index:1010;background:#111827;"
      @click="drawer = !drawer"
    >
      <v-icon color="white">mdi-menu</v-icon>
    </v-btn>

    <v-navigation-drawer
      v-if="authStore.token"
      v-model="drawer"
      width="240"
      style="background: #111827; border-right: 1px solid rgba(255,255,255,0.06);"
      theme="dark"
    >
      <!-- 로고 영역 -->
      <div class="px-5 py-5">
        <div>
          <div style="font-size:15px;font-weight:700;color:#fff;line-height:1.2;">MAPSHOT</div>
          <div style="font-size:11px;color:rgba(255,255,255,0.4);line-height:1.2;">Admin Console</div>
        </div>
      </div>

      <div style="height:1px;background:rgba(255,255,255,0.07);margin:0 16px;" />

      <v-list density="compact" nav class="px-2 mt-2">

        <div class="nav-section-label">GENERAL</div>
        <v-list-item
          v-for="item in home"
          :key="item.to"
          :to="item.to"
          :prepend-icon="item.icon"
          :title="item.title"
          rounded="lg"
          class="nav-item"
          active-class="nav-item-active"
        />

        <div style="height:1px;background:rgba(255,255,255,0.06);margin:8px 4px;" />
        <div class="nav-section-label">공지사항</div>
        <v-list-item
          v-for="item in notice"
          :key="item.to"
          :to="item.to"
          :prepend-icon="item.icon"
          :title="item.title"
          rounded="lg"
          class="nav-item"
          active-class="nav-item-active"
        />

        <div style="height:1px;background:rgba(255,255,255,0.06);margin:8px 4px;" />
        <div class="nav-section-label">지도 데이터</div>
        <v-list-item
          v-for="item in coord"
          :key="item.to"
          :to="item.to"
          :prepend-icon="item.icon"
          :title="item.title"
          rounded="lg"
          class="nav-item"
          active-class="nav-item-active"
        />

        <div style="height:1px;background:rgba(255,255,255,0.06);margin:8px 4px;" />
        <div class="nav-section-label">도시뉴스</div>
        <v-list-item
          v-for="item in cityNews"
          :key="item.to"
          :to="item.to"
          :prepend-icon="item.icon"
          :title="item.title"
          rounded="lg"
          class="nav-item"
          active-class="nav-item-active"
        />

        <div style="height:1px;background:rgba(255,255,255,0.06);margin:8px 4px;" />
        <div class="nav-section-label">커뮤니티</div>
        <v-list-item
          v-for="item in community"
          :key="item.to"
          :to="item.to"
          :prepend-icon="item.icon"
          :title="item.title"
          rounded="lg"
          class="nav-item"
          active-class="nav-item-active"
        />


      </v-list>

      <!-- 하단 세션 -->
      <template v-slot:append>
        <div style="height:1px;background:rgba(255,255,255,0.07);" />
        <div class="pa-3">
          <!-- 세션 타이머 -->
          <div style="background:rgba(255,255,255,0.05);border-radius:10px;padding:10px 14px;margin-bottom:8px;">
            <div class="d-flex align-center justify-space-between mb-1">
              <span style="font-size:12px;color:rgba(255,255,255,0.5);">세션 남은 시간</span>
              <div class="d-flex align-center gap-2">
                <div style="width:6px;height:6px;border-radius:50%;background:#4ade80;" />
                <span style="font-size:13px;font-weight:700;color:#fff;font-variant-numeric:tabular-nums;">{{ getTimer() }}</span>
              </div>
            </div>
            <v-btn
              block
              size="small"
              variant="tonal"
              style="color:#a78bfa;"
              prepend-icon="mdi-refresh"
              @click="authStore.refreshAuth()"
            >
              세션 연장
            </v-btn>
          </div>

          <!-- 로그아웃 -->
          <v-btn
            block
            size="small"
            variant="text"
            color="error"
            prepend-icon="mdi-logout-variant"
            @click="authStore.logout()"
          >
            로그아웃
          </v-btn>
        </div>
      </template>
    </v-navigation-drawer>


    <v-main style="background: #f5f6fa; min-height: 100vh;">
      <!-- 모바일에서 햄버거 버튼 공간 확보 -->
      <div class="d-flex d-md-none" style="height:52px;" />
      <router-view />
    </v-main>

    <!-- 전역 스낵바 -->
    <v-snackbar
      v-model="uiStore.snackbar.show"
      :color="uiStore.snackbar.color"
      :timeout="3000"
      location="bottom right"
      rounded="lg"
      elevation="4"
    >
      <div class="d-flex align-center gap-2">
        <v-icon v-if="uiStore.snackbar.color === 'success'" size="18">mdi-check-circle-outline</v-icon>
        <v-icon v-else-if="uiStore.snackbar.color === 'error'" size="18">mdi-alert-circle-outline</v-icon>
        <v-icon v-else size="18">mdi-information-outline</v-icon>
        {{ uiStore.snackbar.message }}
      </div>
      <template v-slot:actions>
        <v-btn variant="text" size="small" @click="uiStore.snackbar.show = false">닫기</v-btn>
      </template>
    </v-snackbar>

  </v-layout>
</template>

<script>
import { useAuthStore } from '@/store/auth.js'
import { useUiStore } from '@/store/ui.js'

export default {

  setup() {
    const authStore = useAuthStore();
    const uiStore = useUiStore();
    authStore.resumeTimer();
    return { authStore, uiStore }
  },

  data() {
    return {
      drawer: true,
      home: [
        { title: '대시보드', to: '/home', icon: 'mdi-view-dashboard-outline' },
      ],
      notice: [
        { title: '목록', to: '/notice/list', icon: 'mdi-format-list-bulleted' },
        { title: '등록', to: '/notice/create', icon: 'mdi-plus-circle-outline' },
      ],
      coord: [
        { title: '좌표 지도', to: '/coord', icon: 'mdi-map-search-outline' },
      ],
      cityNews: [
        { title: '수집 / 강제 갱신', to: '/news', icon: 'mdi-newspaper-variant-multiple-outline' },
      ],
      community: [
        { title: '게시글 목록', to: '/post', icon: 'mdi-forum-outline' },
      ],
    };
  },

  methods: {
    getTimer() {
      const min = this.authStore.tokenExpirationMinute;
      const h = String(Math.floor(min / 60)).padStart(2, '0');
      const m = String(min % 60).padStart(2, '0');
      return `${h}:${m}`;
    }
  }
}
</script>

<style>
/* 전역 폰트/배경 */
body {
  background: #f5f6fa !important;
}

/* prepend 아이콘과 텍스트 사이 간격 */
.nav-item .v-list-item__prepend {
  padding-inline-end: 14px !important;
}

/* 사이드바 nav 섹션 라벨 */
.nav-section-label {
  font-size: 10.5px;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.35);
  letter-spacing: 0.08em;
  padding: 6px 12px 4px;
}

/* nav 아이템 기본 */
.nav-item .v-list-item-title {
  font-size: 14px !important;
  color: rgba(255, 255, 255, 0.75) !important;
}
.nav-item .v-icon {
  color: rgba(255, 255, 255, 0.45) !important;
}

/* 활성 상태 */
.nav-item-active {
  background: rgba(124, 58, 237, 0.2) !important;
}
.nav-item-active .v-list-item-title {
  color: #c4b5fd !important;
  font-weight: 600 !important;
}
.nav-item-active .v-icon {
  color: #a78bfa !important;
}

/* hover */
.nav-item:hover {
  background: rgba(255, 255, 255, 0.06) !important;
}
</style>
